import { UseGetTreeData } from './type';
import { useEffect, useState } from 'react';
import { getModuleRecordList } from "@/common/asset-apis/assetModel";

export const useGetTreeData: UseGetTreeData = ({ field, FetchAPI, treeType }) => {
  const [treeData, setTreeData] = useState<any[]>([]);
  const [checkBoxData, setCheckBoxData] = useState<any[]>([]);

  useEffect(() => {
    setTreeData(field?.bizConfig?.userList || [])
    const boxData = field?.bizConfig?.userList.map((item:any) => {
      return {
        label: `${item.userName} (${item.userAccount})`,
        value: item.userAccount
      }
    })
    setCheckBoxData(boxData)
  }, []);

  const convert = (data:any) => {
    const obj: Record<any,any> = {}
    data.values && data.values.forEach((item:any) => {
      obj[item.name] = item.value
    })
    return obj
  }

  const onSearch = (val:string) => {
    let boxData = field?.bizConfig?.userList.map((item:any) => {
      return {
        label: `${item.userName} (${item.userAccount})`,
        value: item.userAccount
      }
    })
    if (val) {
      boxData = boxData.filter((item:any) => {
        return item?.label.includes(val)
      })
    }
    setCheckBoxData(boxData)
  }

  const clickMenu = (data:any) => {
    const filterKey = treeType === '组织' ? 'organization_code' : 'position_no'
    getModuleRecordList(
      FetchAPI, 'master_data', 'md_org_job_employee_relation',
      {
        moduleID: 'md_org_job_employee_relation',
        namespaceID: 'master_data',
        filter: `${filterKey} = '${data.key}'`,
      }
    ).then(res => {
      const { set = [] } = res || {}
      const resData = set.map((r:any) => convert(r))
      const userIds:any[] = []
      resData.forEach((item:any) => {
        userIds.push(item.employee_no)
      })
      let boxData = field?.bizConfig?.userList.filter((item:any) => {
        return userIds.includes(item.userAccount)
      })
      boxData = boxData.map((item:any) => {
        return {
          label: `${item.userName} (${item.userAccount})`,
          value: item.userAccount
        }
      })
      setCheckBoxData(boxData)
    })
  }
  
  return {
    treeData,
    checkBoxData,
    onSearch,
    clickMenu,
  };
};
